const PAST_SERVICE_STATUSES = new Set(["executed", "cancelled", "completed"]);

export function playerServicePresentation(service) {
  if (service.player_presentation) return service.player_presentation;
  // Compatibility while an older API response is still in the browser cache.
  const terminal = { executed: "completed", completed: "completed", cancelled: "cancelled", failed: "failed" }[service.status];
  const actions = service.allowed_actions || [];
  const primary = terminal ? null : ["confirm_service_change", "confirm_service_details", "approve_service_cost"].find((action) => actions.includes(action));
  const state = terminal || ({ confirm_service_change: "change_confirmation", confirm_service_details: "confirmation", approve_service_cost: "cost_approval" }[primary])
    || (service.status === "booked" ? "confirmed" : service.status === "problem_reported" ? "problem_review" : "organizing");
  return { state, action_required: Boolean(primary), primary_action: primary };
}

export function isPastPlayerService(service) {
  return PAST_SERVICE_STATUSES.has(service?.workflow_status || service?.status);
}

export function playerServiceCompletedAt(service) {
  const booking = service?.booking || {};
  return service?.executed_at
    || service?.cancelled_at
    || service?.completed_at
    || booking.executed_at
    || booking.cancelled_at
    || booking.completed_at
    || service?.updated_at
    || service?.details?.scheduled_start_at
    || service?.created_at
    || null;
}

function timestamp(value) {
  const parsed = value ? Date.parse(value) : Number.NaN;
  return Number.isNaN(parsed) ? 0 : parsed;
}

export function splitPlayerServices(services = []) {
  const active = [];
  const past = [];
  services.forEach((service) => {
    (isPastPlayerService(service) ? past : active).push(service);
  });
  past.sort((left, right) => timestamp(playerServiceCompletedAt(right)) - timestamp(playerServiceCompletedAt(left)));
  return { active, past };
}
